/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MailOutlineOutlined } from '@mui/icons-material';
import ToolsAnalyticsIcon from 'components/icons/ToolsAnalyticsIcon';
import EducationProgramsIcon from 'components/icons/EducationProgramsIcon';
import CamAppIcon from 'components/icons/CamAppIcon';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NestedList from './listMenu';
import MiniListMenu from './MiniListMenu';
import MiniCounselorListMenu from './MiniCounselorListMenu';
import { routers, toolsAnalyticGroups } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import CounselorListMenu from './CounselorListMenu';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  sanitizeCheckedModule,
  setCheckModule,
  setPartners,
  checkModule as defaultCheckModule,
  getCurrentBasicDetail,
} from 'app/basicInformationSlice/basicInformationSlice';
import { setStudentList } from 'app/counselorSlice';
import { toggleSidebar } from 'app/appSlice';
import { getAccessToken, getUserId } from 'utils/sessionStorage';
import counselorServices from 'services/counselorServices';
import { checkEnableParseJSON, getDefaultCounselorStudentId } from 'components/helper/helper';
import ToolsAnalyticsList from './toolsAnalyticsList';
import MiniToolsAnalyticsMenu from './MiniToolsAnalyticsMenu';
import EducationalProgramsList from './EducationalProgramsList';
import MiniEducationalProgramsMenu from './MiniEducationalProgramsMenu';
import SendNoteModal from '../SendNoteModal';
import toast from 'react-hot-toast';
import { getCamBaseUrl, isGradMapSessionValid, notifyCamSessionExpired, openInCam, showCamPopupBlockedToast } from 'utils/camAuth';
import { STRIPE_PRICE_NAME } from 'constants/common';
//import MessageOutlined from '@ant-design/icons/lib/icons/MessageOutlined';
//import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
//import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
//import AppRegistrationRoundedIcon from '@mui/icons-material/AppRegistrationRounded';


interface Props {
  hideList?: boolean;
}

const SideBar = (props: Props) => {
  const history: any = useHistory();
  let location: any = useLocation();
  const checkModule: any = useAppSelector((store:any) => store.basicInformation.checkModule);
  const sidebarCollapsed: any = useAppSelector((store:any) => store.appStore.sidebarCollapsed);
  const partners = useAppSelector((store:any) => store.basicInformation.partners);
  const dispatch: any = useAppDispatch();
  let id = getUserId();
  const information:any = useAppSelector((store:any) => store.basicInformation.myBasicInformation);
  const role = information?.user_role ?? (sessionStorage.getItem('userRole') || '');
  const [menuIndex, setMenuIndex] = useState<string>(localStorage.getItem('SibarMenuIndex') ?? '1');
  const [isSendNoteModalVisible, setIsSendNoteModalVisible] = useState(false);
  const stripeSubscriptionInfo = useAppSelector(
    (store: any) => store.basicInformation.stripeSubscriptionInfo
  );
  const planName: string = stripeSubscriptionInfo?.subcription_plan ?? STRIPE_PRICE_NAME.GradMapStarter;
  const isStarter = planName === STRIPE_PRICE_NAME.GradMapStarter;

  // Debug: Log when menuIndex changes
  useEffect(() => {
  }, [menuIndex, role, sidebarCollapsed, props.hideList]);

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const getRole = async () =>{
      await dispatch(getCurrentBasicDetail(id));
  }
  useEffect(() => {
    getRole();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (role && role!== "") {
        sessionStorage.setItem('userRole', role);
        if (role === 'counselor' || role === 'parent') {
          // Only call the API if there is no data in the Redux store.
          if (!partners || partners.length === 0) {
            try {
              counselorServices.getPartner(Number(id)).then(async (res: any) => {
                if (res && res.length > 0) {
                  let arr: any[] = [...res];
                  for (let i = 0; i < arr.length; i++) {
                    let f_update = false;
                    let notes_array: any = checkEnableParseJSON(arr[i].notes_array);
                    if (notes_array === null) {
                      notes_array = {
                        checkModule: defaultCheckModule,
                      };
                      f_update = true;
                    }
                    if (!f_update) {
                      // if ("9.1" in notes_array.checkModule) {
                      //     f_update = false;
                      // }
                      if ('5.9' in notes_array.checkModule) {
                        f_update = false;
                      } else {
                        f_update = true;
                      }
                    }

                    if (f_update) {
                      notes_array.checkModule = sanitizeCheckedModule(notes_array.checkModule);
                      arr[i].notes_array = JSON.stringify(notes_array);
                      let partner: any = await counselorServices.getPartnerById(arr[i].id);

                      if (partner) {
                        partner.notes_array = JSON.stringify(notes_array);
                        await counselorServices.updatePartnerById(partner);
                      }
                    }
                  }
                }
                dispatch(setPartners(res));
                dispatch(setStudentList(res ?? []));
              }).catch((error) => {
                console.error('Error fetching partner data for role:', role, error);
                // For parent role, if API fails, set empty partners array
                if (role === 'parent') {
                  dispatch(setPartners([] as any));
                  dispatch(setStudentList([]));
                }
              });
            } catch (error) {
              console.error('Error in getData for role:', role, error);
              if (role === 'parent') {
                dispatch(setPartners([] as any));
                dispatch(setStudentList([]));
              }
            }
          }
        } 
        else {
          // role==='student'
          // Only call the API if the checkModule is not already present
          if (!checkModule) {
            counselorServices.getCounselors(Number(id)).then((res: any) => {
              const loadedCheckModule = checkEnableParseJSON(res[0]?.notes_array, {
                checkModule,
                notes: [],
              })?.checkModule;
              dispatch(setCheckModule(loadedCheckModule));
            });
          }
        }
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, id]);

  useEffect(() => {
    try {
      // Determine the active icon purely from the current route, not from
      // whatever menuIndex happened to be set to before this navigation —
      // otherwise a stale '3' (Tools & Analytics) from a previous page/session
      // stays highlighted even when landing on an unrelated /application/* page
      // (e.g. Basic Information right after login).
      const isToolsAnalyticsPath =
        !!(toolsAnalyticGroups &&
        toolsAnalyticGroups[0] &&
        toolsAnalyticGroups[0].children &&
        toolsAnalyticGroups[0].children.length > 0 &&
        toolsAnalyticGroups[0].children.some((o: any) => location.pathname.includes(o.path)));

      if (location.pathname.includes('/dashboard')) {
        const newIndex = '1';
        localStorage.setItem('SibarMenuIndex', newIndex);
        setMenuIndex(newIndex);
      } else if (isToolsAnalyticsPath) {
        const newIndex = '3';
        localStorage.setItem('SibarMenuIndex', newIndex);
        setMenuIndex(newIndex);
      } else if (location.pathname.includes('/application')) {
        const newIndex = '2';
        localStorage.setItem('SibarMenuIndex', newIndex);
        setMenuIndex(newIndex);
      } else if (location.pathname.includes('/summer-programs')) {
        const newIndex = '4';
        localStorage.setItem('SibarMenuIndex', newIndex);
        setMenuIndex(newIndex);
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  }, [location]);

  return (
    <div className="w-100 h-100 d-flex position-relative">
      <div className="gm-sidebar-toolbar">
        <OverlayTrigger
          placement={'right'}
          overlay={
            <Tooltip id={`tooltip-dashboard`}>
              <strong>Dashboard</strong>
            </Tooltip>
          }
        >
          <Button
            className={`py-3 border-top rounded-0 ${
              menuIndex === '1' ? 'bg-primary text-white' : 'text-field-light'
            }`}
            variant="outline"
            onClick={() => {
              const newIndex = '1';
              localStorage.setItem('SibarMenuIndex', newIndex);
              setMenuIndex(newIndex);
              history.push({
                pathname: routers.dashBoard.path,
                search: `?role=${role}`,
              });
            }}
          >
            <LaunchOutlinedIcon className="my-3" />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement={'right'}
          overlay={
            <Tooltip id={`tooltip-application`}>
              <strong>{role === 'counselor' || role === 'parent' ? 'Students' : 'Application'}</strong>
            </Tooltip>
          }
        >
          <Button
            className={`py-3 border-top rounded-0 ${
              menuIndex === '2' ? 'bg-primary text-white' : 'text-field-light'
            }`}
            variant="outline"
            onClick={async () => {
              const newIndex = '2';
              localStorage.setItem('SibarMenuIndex', newIndex);
              setMenuIndex(newIndex);
              if (role === 'counselor' || role === 'parent') {
                const uid = getUserId();
                if (!uid) {
                  toast.error('Unable to open students');
                  return;
                }
                try {
                  const res = await counselorServices.getPartner(uid);
                  const firstId = getDefaultCounselorStudentId(res);
                  if (firstId) {
                    history.push(routers.viewStudent.path.replace(':id', String(firstId)));
                  } else {
                    toast.error('No students linked yet');
                  }
                } catch {
                  toast.error('Could not load students');
                }
              } else {
                history.push(routers.basicInformation.path);
              }
            }}
          >
            <ContentPasteOutlinedIcon className="my-3" />
          </Button>
        </OverlayTrigger>

        {(role === 'student') && (
          <>
          <OverlayTrigger
            placement={'right'}
            overlay={
              <Tooltip id={`tooltip-dashboard`}>
                <strong>Tools & Analytics</strong>
              </Tooltip>
            }
          >
            <Button
              className={`py-3 border-top rounded-0 ${
                menuIndex === '3' ? 'bg-primary text-white' : 'text-field-light'
              }`}
              variant="outline"
              onClick={() => {
                const newIndex = '3';
                localStorage.setItem('SibarMenuIndex', newIndex);
                setMenuIndex(newIndex);
                history.push(routers.gpaForecaster.path);
              }}
            >
              <ToolsAnalyticsIcon className="my-3" />
            </Button>
          </OverlayTrigger>

        <OverlayTrigger
          placement={'right'}
          overlay={
            <Tooltip id={`tooltip-dashboard`}>
              <strong>Educational Programs</strong>
            </Tooltip>
          }
        >
          <Button
            className={`py-3 border-top rounded-0 ${
              menuIndex === '4' ? 'bg-primary text-white' : 'text-field-light'
            }`}
            variant="outline"
            onClick={() => {
              const newIndex = '4';
              localStorage.setItem('SibarMenuIndex', newIndex);
              setMenuIndex(newIndex);
              history.push(routers.summerProgramsBrowser.path);
            }}
          >
            <EducationProgramsIcon className="my-3" />
          </Button>
        </OverlayTrigger>
        </>
        )}

        {!isStarter && (
        <OverlayTrigger
          placement={'right'}
          overlay={
            <Tooltip id={`tooltip-cam`}>
              <strong>CAM</strong>
            </Tooltip>
          }
        >
          <Button
            className="py-3 border-top rounded-0 text-field-light"
            variant="outline"
            onClick={async () => {
              let hasToken = !!getAccessToken();
              if (!hasToken) {
                notifyCamSessionExpired();
                return;
              }

              // Token is present but may already be expired/revoked server-side —
              // confirm with the backend before handing it off to CAM.
              const sessionValid = await isGradMapSessionValid();
              if (!sessionValid) {
                notifyCamSessionExpired();
                return;
              }

              if (!getCamBaseUrl()) {
                toast.error('CAM is not configured. Please contact support.');
                return;
              }
              if (!openInCam('/')) {
                showCamPopupBlockedToast(toast.error, routers.helpPopUp.path);
              }
            }}
          >
            <CamAppIcon className="my-3" />
          </Button>
        </OverlayTrigger>
        )}

        <OverlayTrigger
          placement={'right'}
          overlay={
            <Tooltip id={`tooltip-send-note`}>
              <strong>Send Note</strong>
            </Tooltip>
          }
        >
          <Button
            className={`py-3 border-top rounded-0 ${
              menuIndex === '5' ? 'bg-primary text-white' : 'text-field-light'
            }`}
            variant="outline"
            onClick={() => {
              const newIndex = '5';
              localStorage.setItem('SibarMenuIndex', newIndex);
              setMenuIndex(newIndex);
              setIsSendNoteModalVisible(true);
            }}
          >
            <MailOutlineOutlined className="my-3" />
          </Button>
        </OverlayTrigger>
      </div>


      {!props.hideList && !sidebarCollapsed && (
        <div className="w-100 position-relative">
          {(role === 'counselor' || role === 'parent') && <CounselorListMenu />}
          {role === 'student' && (
            <>
              {menuIndex === '2' && <NestedList />}
              {menuIndex === '3' && (
                <>
                  <ToolsAnalyticsList />
                </>
              )}
              {menuIndex === '4' && (() => {
                return (
                  <>
                    <EducationalProgramsList />
                  </>
                );
              })()}
            </>
          )}
        </div>
      )}

      {/* Toggle Button - located outside the list menu, next to it */}
      {!props.hideList && !sidebarCollapsed && (
        <Button
          variant="outline"
          className="position-absolute text-primary"
          style={{
            top: '50%',
            right: '-18px',
            transform: 'translateY(-50%)',
            zIndex: 1000,
            backgroundColor: '#ffffff',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            border: '2px solid #007bff',
            boxShadow: '0 4px 12px rgba(0,123,255,0.3)',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
          }}
          onClick={handleToggleSidebar}
        >
          <ChevronLeftIcon fontSize="small" />
        </Button>
      )}
      {sidebarCollapsed && (
        <div className="position-relative" style={{ width: '60px' }}>
          {/* Mini Sidebar */}
          {(role === 'counselor' || role === 'parent') ? (
            <div className="h-100 position-relative">
              <MiniCounselorListMenu />
            </div>
          ) : (
            <>
              {menuIndex === '2' && (
                <div className="h-100 position-relative">
                  <MiniListMenu />
                </div>
              )}
              {menuIndex === '3' && (
                <div className="h-100 position-relative">
                  <MiniToolsAnalyticsMenu />
                </div>
              )}
              {menuIndex === '4' && (() => {
                console.log("🚀 ~ SideBar ~ Rendering MiniEducationalProgramsMenu, menuIndex:", menuIndex, "role:", role, "sidebarCollapsed:", sidebarCollapsed);
                return (
                  <div className="h-100 position-relative">
                    <MiniEducationalProgramsMenu />
                  </div>
                );
              })()}
            </>
          )}
        </div>
      )}

      {/* Toggle Button for mini sidebar - located outside, next to the mini menu */}
      {sidebarCollapsed && (
        <Button
          variant="outline"
          className="position-absolute text-primary"
          style={{
            top: '50%',
            right: '-18px',
            transform: 'translateY(-50%)',
            backgroundColor: '#ffffff',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            border: '2px solid #007bff',
            boxShadow: '0 4px 12px rgba(0,123,255,0.3)',
            transition: 'all 0.2s ease',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
          }}
          onClick={handleToggleSidebar}
        >
          <ChevronRightIcon fontSize="small" />
        </Button>
      )}

      {/* Send Note Modal */}
      <SendNoteModal
        visible={isSendNoteModalVisible}
        userType={role}
        conversationId=""
        onCancel={() => setIsSendNoteModalVisible(false)}
      />
    </div>
  );
};

export default SideBar;
